<div class="p-fluid">
    <p-autoComplete #items="ngModel" #autocomplete type="text" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" 
    [suggestions]="filteredList" [ngModel]="value" (ngModelChange)="update($event)" (completeMethod)="filter($event)"
    (onFocus)="!autocomplete.value && autocomplete.handleDropdownClick($event)" required>
    </p-autoComplete>
    <div class="error" *ngIf="required && showErrors && (form.submitted || items.dirty) && items.invalid">
    </div>
</div>